import React, { useState, useRef, useEffect } from 'react';
import './style.css'; 

interface Option {
  id: string;
  name: string;
}

interface MultiSelectProps {
  options: Option[];
  selectedOptions: Option[];
  onChange: (selected: Option[]) => void;
  placeholder?: string;
}

const MultiSelectDropdown: React.FC<MultiSelectProps> = ({
  options,
  selectedOptions,
  onChange,
  placeholder = 'Select distributors',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (option: Option) => {
    const isSelected = selectedOptions.some(item => item.id === option.id);
    if (isSelected) {
      onChange(selectedOptions.filter(item => item.id !== option.id));
    } else {
      onChange([...selectedOptions, option]);
    }
  };

  const selectedNames = selectedOptions.map(option => option.name).join(', ');

  return (
    <div className="multi-select-container" ref={dropdownRef}>
      <div className="multi-select-header" onClick={handleToggle}>
        <span className="selected-items">
          {selectedOptions.length > 0 ? selectedNames : placeholder}
        </span>
        <span className={`dropdown-icon ${isOpen ? 'open' : ''}`}>&#9660;</span>
      </div>
      {isOpen && (
        <div className="multi-select-list">
          {options.map(option => (
            <div key={option.id} className="list-item">
              <input
                type="checkbox"
                style={{width:30}}
                id={`distributor-${option.id}`}
                checked={selectedOptions.some(item => item.id === option.id)}
                onChange={() => handleCheckboxChange(option)}
              />
              <label htmlFor={`distributor-${option.id}`}>{option.name}-{option.id}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;